import { gql } from "@apollo/client";
import { INTERVIEW_QUESTION_FIELDS, INTERVIEW_RESPONSE_ANSWER_FIELDS } from "graphql/fragments";

const GET_INTERVIEW_RESPONSES = gql`
  ${INTERVIEW_QUESTION_FIELDS}
  ${INTERVIEW_RESPONSE_ANSWER_FIELDS}
  query interviewResponses(
    $filters: InterviewResponseFilter
    $first: Int
    $last: Int
    $after: String
    $before: String
  ) {
    interviewResponses(filters: $filters, first: $first, last: $last, after: $after, before: $before) {
      nodes {
        id
        uuid
        slug
        type
        status
        completed
        publicUrl
        privateUrl
        answers {
          ...InterviewResponseAnswerFields
        }
        deletedAt
        createdAt
        completedAt
        missionRoleApplicant {
          id
        }
        interview {
          id
          name
          missionRole {
            id
            name
            slug
            mission {
              uuid
            }
          }
          questions {
            ...InterviewQuestionFields
          }
        }
      }
    }
  }
`;

const GET_INTERVIEW_RESPONSE = gql`
  ${INTERVIEW_QUESTION_FIELDS}
  ${INTERVIEW_RESPONSE_ANSWER_FIELDS}
  query interviewResponse($uuid: ID!, $enabled: Boolean) {
    interviewResponse(uuid: $uuid) {
      id
      uuid
      slug
      type
      status
      completed
      publicUrl
      privateUrl
      answers {
        ...InterviewResponseAnswerFields
      }
      deletedAt
      createdAt
      interview {
        id
        name
        videoUrl
        introVideoUrl
        questions(enabled: $enabled) {
          ...InterviewQuestionFields
        }
      }
      profileId
    }
  }
`;

const GET_INTERVIEW_RESPONSE_ANSWER_SCORES = gql`
  query interviewResponseAnswerScores($interviewResponseAnswerIds: [ID!]!) {
    interviewResponseAnswerScores(interviewResponseAnswerIds: $interviewResponseAnswerIds) {
      interviewResponseAnswerId
      vectorRank
      vectorScore
    }
  }
`;

export { GET_INTERVIEW_RESPONSES, GET_INTERVIEW_RESPONSE, GET_INTERVIEW_RESPONSE_ANSWER_SCORES };
